// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import React from 'react'
import { bool, string } from 'prop-types'
import { connect } from 'react-redux'
import { PATH_REPORT_EXPORT } from './constants'
import { Field } from 'redux-form'
import { CheckboxGroup } from 'components/Form'

class UnderlineCheck extends React.Component {
  static propTypes = {
    idRoot: string.isRequired,
    showUnderlineCheck: bool.isRequired,
  }

  options = [{
    label: 'Underline changed fields?',
    value: 'true',
  }]

  render () {
    const {
      idRoot,
      showUnderlineCheck,
    } = this.props

    return (
      <div className={showUnderlineCheck ? '' : 'display-none'}>
        <Field
          checkBoxClasses={'padding-top-half display-flex flex-direction-column'}
          component={CheckboxGroup}
          idRoot={idRoot}
          name={'underline'}
          options={this.options} />
      </div>
    )
  }
}

const mapStateToProps = ({ form }) => {
  const { pathExportTypes } = form[PATH_REPORT_EXPORT].values

  const showUnderlineCheck = (
    pathExportTypes.includes('docx') ||
    pathExportTypes.includes('pdf')
  )

  return {
    showUnderlineCheck,
  }
}

export default connect(
  mapStateToProps,
)(UnderlineCheck)
